"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../../../toolkit/styling");

var _Link = _interopRequireDefault(require("../../../button/Link"));

var _BasicColumn = _interopRequireWildcard(require("./BasicColumn"));

//
//  src/data/table/LinkColumn.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 12/23/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */

/* Lego Components */

/* Relative Imports */
var LinkColumn = (0, _mobxReact.observer)(function (props) {
  var href = props.href,
      text = props.text,
      openInNewTab = props.openInNewTab,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["href", "text", "openInNewTab"]);
  var styles = useStylesheet(props);
  return /*#__PURE__*/_react["default"].createElement(_BasicColumn["default"], otherProps, function (cell) {
    // Support functional dynamic href and static value
    var href = (0, _BasicColumn.extractConfig)(props, "href", cell);
    var text = (0, _BasicColumn.extractConfig)(props, "text", cell);

    if (href == null || href.trim().length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, text);
    }

    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      className: (0, _styling.css)(styles.link),
      href: href,
      openInNewTab: openInNewTab
    }, text);
  });
});
var _default = LinkColumn;
exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var align = props.align;
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      link: {
        textAlign: align,
        maxWidth: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden"
      }
    });
  }, [align]);
};